<template>
  <div v-if="text" class="Mw-PostLogin-thankyou-custom-text">
    <p>{{ localizedText }}</p>
  </div>
</template>

<script>
  export default {
    props: {
      option: {
        type: Array,
      },
    },
    data() {
      return {
        localizedText: null,
      }
    },
    computed: {
      text() {
        const actionName = 'Custom Text'
        return this.option.find((a) => a.action === actionName)
      },
      baseData() {
        return this.$store.state.baseData
      },
    },
    watch: {
      baseData: {
        deep: true,
        handler() {
          this.customText()
        },
      },
    },
    mounted() {
      const plume = localStorage.getItem('isPlume')
      const pathName = window.location.pathname
      const parts = pathName.split('/')
      const pageName = parts.filter((part) => part.includes('.html'))[0]

      if (this.baseData.flags.showMultilingual || plume) {
        // should be already present
        const localStorageLanguage = JSON.parse(localStorage.getItem('selectedLanguage'))
        const value = localStorageLanguage[pageName]

        if (pageName && value) {
          this.$i18n.locale = value
        }
      } // single language campaign and non-plume campaign's it will use default language code
      this.customText()
    },
    methods: {
      customText() {
        const option = JSON.parse(JSON.stringify(this.option))
        if (this.text && this.text.text) {
          this.localizedText = this.text.text
        } else if (this.baseData?.flags?.showMultilingual) {
          if (this.baseData?.development?.preview) {
            // [portal-multilingual-crash] see language.vue's updateLang() --
            // same unguarded baseData.development.currentLanguage read.
            this.$i18n.locale =
              this.baseData.development?.currentLanguage?.langCode ||
              this.baseData?.language?.defaultLanguage?.langCode ||
              this.$i18n.locale
          }
          this.localizedText = this.$t('enjoy_browsing')
        } else {
          this.localizedText = this.text.text
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .Mw-PostLogin-thankyou-custom-text {
    padding: 20px;
    p {
      font-size: 14px;
      text-align: center;
      line-height: 20px;
    }
  }
</style>
